import {
  Badge,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
} from '@chakra-ui/react';
import { ReactNode } from 'react';

export interface EntityLifecycleTab<TValue extends string> {
  label: string;
  value: TValue;
  count: number;
}

interface Props<TValue extends string> {
  active: TValue;
  children: ReactNode;
  filters: ReactNode;
  items: readonly EntityLifecycleTab<TValue>[];
  label: string;
  onChange: (value: TValue) => void;
}

export function EntityLifecycleTabs<TValue extends string>({
  active,
  children,
  filters,
  items,
  label,
  onChange,
}: Props<TValue>) {
  return (
    <Tabs
      index={items.findIndex((item) => item.value === active)}
      onChange={(index) => onChange(items[index].value)}
      variant="entity-lifecycle"
    >
      <TabList aria-label={label}>
        {items.map((item) => (
          <Tab key={item.value}>
            {item.label}
            <Badge data-lifecycle-count="">{item.count}</Badge>
          </Tab>
        ))}
      </TabList>
      {filters}
      <TabPanels>
        {items.map((item) => (
          <TabPanel key={item.value}>
            {item.value === active ? children : null}
          </TabPanel>
        ))}
      </TabPanels>
    </Tabs>
  );
}
